import type {Theme} from '../theme';
import {createBaseThemeVariation} from './base';

export const SeymourHouseTheme: Theme = createBaseThemeVariation({
    name: 'seymourhouse',
    brandColor: 'hsla(172, 100%, 28%, 1)',
    primaryColors: {
        p50: 'hsla(305, 42%, 98%, 1)',
        p75: 'hsla(305, 44%, 96%, 1)',
        p100: 'hsla(305, 46%, 94%, 1)',
        p200: 'hsla(303, 54%, 79%, 1)',
        p300: 'hsla(304, 54%, 57%, 1)',
        p400: 'hsla(304, 54%, 29%, 1)',
        p500: 'hsla(304, 75%, 16%, 1)',
    },
});
